"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var CommonHeading = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(CommonHeading, _React$Component);

  function CommonHeading() {
    return _React$Component.apply(this, arguments) || this;
  }

  CommonHeading.resourceType = function resourceType() {
    return 'Common_Heading_1_0_0';
  };

  var _proto = CommonHeading.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Tag = _this$props.tag,
        text = _this$props.text,
        className = _this$props.className;
    return /*#__PURE__*/_react["default"].createElement(Tag, {
      className: className
    }, text);
  };

  return CommonHeading;
}(_react["default"].Component);

exports["default"] = CommonHeading;
CommonHeading.defaultProps = {
  text: '',
  tag: 'h1',
  className: ''
};